/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, string, shape,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';

const DescriptionSection = ({
    customClasses,
    dataDictionary,
    partNumber,
    language,
    brand,
    pdpDictionary,
    longDescription,
}) => {
    const classes = customClasses;
    const [showLongDescription, setShowLongDescription] = useState(false);
    const [readMore, readLess] = ['Read more', 'Read less'];
    return (
        <div className={classes.descriptionBlock}>
            <div className={classes.subHeading}>
                <h2>{language === '/en' ? 'Product Details' : dataDictionary['Product Details']}</h2>: <span>{partNumber}</span>
            </div>
            <div>
                {/**
                  * @intention
                  * - Desktop: Always visible
                  * - Mobile: Hidden by default. Toggle visibility (read more/less)
                  */}
                <div className={`${classes.longDescription} ${brand.code === 'PLA' ? 'plaLongDescription' : null} ${classes.longDesLInks}`}>
                    {/* temporary workaround for translations. Only applies for .CA */}
                    <ReactMarkdown source={language !== '/en' && brand?.code === 'CAN' ? pdpDictionary?.[`${partNumber}_long_description`] || longDescription : longDescription} escapeHtml={false} />
                </div>
                {
                    showLongDescription
                    && (
                        <div className={showLongDescription ? '' : classes.hidden}><ReactMarkdown source={language !== '/en' && brand?.code === 'CAN' ? pdpDictionary?.[`${partNumber}_long_description`] || longDescription : longDescription} escapeHtml={false} />
                        </div>
                    )
                }
                <div className={`${classes.longDescriptionMobile} ${brand.code === 'PLA' ? 'plaShowToggle' : null}`}>
                    <button
                        className={classes.toggleDescription}
                        type="button"
                        onClick={() => setShowLongDescription(!showLongDescription)}
                    >
                        { /* eslint-disable no-nested-ternary */
                            language === '/en'
                                ? showLongDescription
                                    ? readLess
                                    : readMore
                                : showLongDescription
                                    ? dataDictionary?.[readMore] || readMore
                                    : dataDictionary?.[readLess] || readLess
                        }
                    </button>
                </div>
            </div>
        </div>
    );
};

DescriptionSection.propTypes = {
    customClasses: object.isRequired,
    partNumber: string.isRequired,
    longDescription: string.isRequired,
    dataDictionary: object.isRequired,
    brand: shape({
        code: string.isRequired,
    }).isRequired,
    language: string.isRequired,
    pdpDictionary: string.isRequired,
};

export default DescriptionSection;
